import React, { lazy, useEffect } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";
import { themeChange } from "theme-change";
import checkAuth from "./app/auth";
import initializeApp from "./app/init";
import routes from "./routes";
import PrivateRoutes from "./components/Alerts/PrivateRoutes";
import SchoolTeacherLogin from "./SchoolTeacher/Auth/SchoolTeacherLogin";
import SchoolTeacherForgetPass from "./SchoolTeacher/Auth/SchoolTeacherForgetPass";

// Importing pages
const Layout = lazy(() => import("./containers/Layout"));
const Login = lazy(() => import("./pages/Login"));
const LandingPage = lazy(() => import("./pages/LandingPage"));
const ThankYou = lazy(() => import("./pages/ThankYou"));

const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const ResetPassword = lazy(() => import("./features/user/ChangePassword"));
const OtpVerification = lazy(() => import("./features/user/Otp"));
const SchoolAdminLogin = lazy(
  () => import("./SchoolAdmin/Auth/SchoolAdminLogin"),
);
const SchoolAdminForgetPassword = lazy(
  () => import("./SchoolAdmin/Auth/SchoolAdminForgetPassword"),
);

// Initializing different libraries
initializeApp();

// Check for login and initialize axios
const token = checkAuth();

function App() {
  useEffect(() => {
    // 👆 daisy UI themes initialization
    themeChange(false);
  }, []);

  return (
    <>
      <Router>
        <Routes>
          {/* PUBLIC AUTH ROUTES */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/superadmin" element={<Login />} />
          <Route path="/school-admin/login" element={<SchoolAdminLogin />} />
          <Route path="/:role/forgot-password" element={<ForgotPassword />} />
          <Route
            path="/:role/forget-password"
            element={<SchoolAdminForgetPassword />}
          />
          <Route
            path="/:role/forget-pass"
            element={<SchoolTeacherForgetPass />}
          />
          <Route path="/otp-verification" element={<OtpVerification />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/teacher/login" element={<SchoolTeacherLogin />} />

          {/* PROTECTED APP */}
          <Route
            path="/app/*"
            element={
              <PrivateRoutes>
                <Layout />
              </PrivateRoutes>
            }
          />
        </Routes>
      </Router>
    </>
  );
}

export default App;
